import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import { lineHeight } from '@mui/system';

export const useStyles = makeStyles((theme: Theme) => ({
  mentorshipCard: {
    backgroundColor: '#5981FF',
    borderRadius: '12px !important',
    padding: 5,
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      padding: '0px',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      height: '58vh',
    },
  },
  mentorBtns: {
    marginLeft: '0px !important',
    borderRadius: '8px !important',
    padding: '10px !important',
    fontSize: '14px !important',
    fontWeight: '500 !important',
    textTransform: 'lowercase',
  },
  mentortitle: {
    color: '#FFFFFF',
    fontSize: '15px !important',
    fontWeight: '600 !important',
    textAlign: 'left',
    marginTop: '40px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
    },
  },
  mentorContent: {
    color: '#FFFFFF',
    fontSize: '12px !important',
    fontWeight: '400 !important',
    textAlign: 'left',
    marginTop: 10,
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  cardStyle: {
    borderRadius: '15px !important',
    marginTop: 20,
    padding: 15,
    boxShadow: 'none !important',
  },
  cardStyleEven: {
    borderRadius: '15px !important',
    marginTop: 20,
    padding: 15,
    boxShadow: 'none !important',
  },
  mentorCard: {
    borderRadius: '12px !important',
    padding: 15,
    boxShadow: 'none !important',
    height: '26.67vh',
    [theme.breakpoints.up('xxl')]: {
      height: '24vh',
    },
    '@media (min-width: 1536px) and (max-width: 1636px)': {
      height: '22vh !important',
    },
    '@media (min-width: 1920px) and (max-width: 2000px)': {
      height: '24.5vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '19vh',
    },
  },
  mentorTitleCard: {
    color: '#3061FF',
    fontSize: '15px !important',
    fontWeight: 500,
    textAlign: 'left',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
    },
  },
  mentorContentCard: {
    color: '#373A45',
    fontSize: '12px !important',
    textAlign: 'left',
    marginTop: 5,
    paddingRight: '5px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      lineHeight: '25px !important',
    },
  },
  preferCardForm: {
    borderRadius: '12px !important',
    padding: 20,
    boxShadow: 'none !important',
  },
  mentorDetailCard: {
    borderRadius: '10px !important',
    padding: 10,
    boxShadow: 'none !important',
  },
  hr: {
    borderLeft: '1px solid #E6E6E8',
    height: '100%',
    margin: '0px',
  },
  menteeName: {
    fontSize: '15px !important',
    fontWeight: '500 !important',
    textAlign: 'left',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
    },
  },
  subTitleMentee: {
    fontSize: '10.5px',
    marginTop: '12px !important',
    textAlign: 'left',
    color: '#585A64',
    fontWeight: '400 !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px',
    },
  },
  subContentMentee: {
    fontSize: '10.5px !important',
    marginTop: '12px !important',
    textAlign: 'left',
    color: '#585A64',
    fontWeight: '500 !important',
    marginLeft: '10px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px',
    },
  },
  menteeYear: {
    fontSize: '13px !important',
    textAlign: 'center',
    color: '#585A64',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '11px',
    },
  },
  activeColor: {
    backgroundColor: '#EAEFFF',
    borderLeft: '4px solid #3061FF',
    borderRadius: '10px !important',
    padding: 15,
    marginRight: '10px !important',
  },
  nonActiveColor: {
    padding: 15,
    marginRight: '10px !important',
  },
  menteeDetailCard: {
    padding: 10,
    borderRadius: '15px !important',
  },
  menteeDetailName: {
    fontSize: '12px',
    fontWeight: '500 !important',
    textAlign: 'left',
  },
  menteeDetailContent: {
    fontSize: '10.5px',
    textAlign: 'left',
  },
  menteeDetailMsg: {
    fontSize: '10.5px',
    padding: '5px !important',
    width: 170,
    fontWeight: '500 !important',
    backgroundColor: '#E6E6E8',
    borderRadius: '20px !important',
    marginTop: '15px !important',
  },
  menteeDetailMsg1: {
    fontSize: '10.5px',
    padding: '5px !important',
    width: 50,
    fontWeight: '500 !important',
    backgroundColor: '#E6E6E8',
    borderRadius: '20px !important',
    marginTop: '15px !important',
    marginLeft: '10px !important',
  },
  menteeDetailMsg2: {
    fontSize: '10.5px',
    padding: '5px !important',
    width: 70,
    fontWeight: '500 !important',
    backgroundColor: '#E6E6E8',
    borderRadius: '20px !important',
    marginTop: '15px !important',
    marginLeft: '10px !important',
  },
  divider: {
    background: 'linear-gradient(270deg, rgba(191, 206, 255, 0) 0%, #BFCEFF 100%)',
    height: '2px',
  },
  entireContainer: {
    background: '#fff',
    height: '83vh',
    borderRadius: '12px',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '81vh !important',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      height: '83.8vh !important',
    },
  },
  editIcon: {
    color: '#000',
    background: '#fff',
    padding: '5px',
    borderRadius: '12px',
  },
  sepContainer: {
    background: '#F6F8FB',
    borderRadius: '6px',
    marginBottom: '16px',
    padding: '10px 16px',
    '& .MuiGrid-item': {
      padding: '8px',
    },
  },
  rightHeadings: {
    '&.MuiTypography-root': {
      fontSize: '15px',
      fontWeight: '500',
      color: '#373A45',
    },
  },
  labelName: {
    fontSize: '12px',
    fontWeight: '500 !important',
  },
  radioGroup: {
    display: 'flex',
    justifyContent: 'start',
  },
  formControlLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '200px', // Adjust this width based on your design needs
  },
  jobPreferenceTitle: {
    textAlign: 'left',
    fontWeight: '530 !important',
    marginTop: 10,
    fontSize: 17.5,
  },
  jobPreferCard: {
    borderRadius: 12,
    padding: 15,
    boxShadow: 'none !important',
    height: '84vh',
  },
  jobPreferCards: {
    backgroundColor: '#F6F8FB',
    borderRadius: 5,
    padding: 10,
    marginTop: 10,
    boxShadow: 'none !important',
  },
  mentorBox: {
    height: '18vh',
    [theme.breakpoints.up('xxl')]: {
      height: '17.5vh',
    },
    '@media (min-width: 1536px) and (max-width: 1636px)': {
      height: '15vh !important',
    },
    '@media (min-width: 1920px) and (max-width: 2000px)': {
      marginTop: '15px !important',
      height: '24vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '11vh !important',
    },
  },
  mentorDetailBox: {
    height: '39vh',
    [theme.breakpoints.up('xxl')]: {
      height: '38vh',
    },
    '@media (min-width: 1536px) and (max-width: 1636px)': {
      height: '35.5vh !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '34.5vh',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      height: '40.7vh !important',
    },
  },
  mentorForm: {
    height: '57vh',
    [theme.breakpoints.up('xxl')]: {
      height: '63vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '55vh !important',
    },
  },
}));
